import styled from 'styled-components';
import { ReactComponent as IconPessoa } from "assets/icon/4.svg";

const Icon = styled(IconPessoa)`
  width: 20px;
  height: 20px;
  fill: ${(props) => (props.active ? "#38b6ff" : "#d3d3d3")}; // Cor alterada de acordo com a condição
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 5px;
`;

export { Icon, Grid }